import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const BannerQuery = gql`
  query($domain: String!) {
    banners(domain: $domain) {
      id
      file
      productImage
      name
      type
      title
      subtitle
      description
      link
      priority
    }
    languages {
      id
      value
    }
  }
`;

const CreateBannerMutation = gql`
  mutation($banner: CreateBannerInput!) {
    createBanner(banner: $banner) {
      id
    }
  }
`;

const UpdateBannerMutation = gql`
  mutation($id: String!, $banner: UpdateBannerInput!) {
    updateBanner(id: $id, banner: $banner) {
      id
    }
  }
`;

const DeleteBannerMutation = gql`
  mutation($id: String!) {
    deleteBanner(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
  domain: string;
}

interface Response {
  data: any;
}

class GetBannerQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const { banners, createBanner, updateBanner, deleteBanner }: any = this.props;
    return this.props.children({
      banners,
      createBanner,
      updateBanner,
      deleteBanner
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(BannerQuery, {
    name: 'banners',
    options: props => ({
      variables: { domain: props.domain }
    })
  }),
  graphql<IInputProps, Response>(CreateBannerMutation, {
    name: 'createBanner'
  }),
  graphql<IInputProps, Response>(UpdateBannerMutation, {
    name: 'updateBanner'
  }),
  graphql<IInputProps, Response>(DeleteBannerMutation, {
    name: 'deleteBanner'
  })
)(GetBannerQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Banners/Banners.tsx